(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["departments"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  let observer;
  const active = new Set();
  function setup() {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (preference.matches || !entry.target.animate) return;
        const animation = entry.target.animate([
          { opacity: 0.45, transform: 'translateY(14px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 550, easing: 'cubic-bezier(.2,.65,.3,1)' });
        active.add(animation);
        animation.onfinish = () => active.delete(animation);
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.department,.lifestyle-banner,.faq-layout,.newsletter-layout,.contact-layout,.market-products .card').forEach(element => {
      if (!seen.has(element)) { seen.add(element); observer.observe(element); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
  preference.addEventListener('change', () => {
    if (preference.matches) {
      if (observer) { observer.disconnect(); observer = null; }
      active.forEach(animation => animation.cancel());
      active.clear();
    } else setup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.store-header details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})}});
document.addEventListener('click',event=>{document.querySelectorAll('.store-header details[open]').forEach(d=>{if(!d.contains(event.target))d.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change',function(e){if(!e.target.matches('[data-variant-select]'))return;const s=e.target,o=s.selectedOptions[0],b=document.getElementById('Add-'+s.dataset.section);document.getElementById('Price-'+s.dataset.section).textContent=o.dataset.price;b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.sold:b.dataset.add;document.querySelector('#Gallery-'+s.dataset.section+' fawri-gallery')?.goMedia(o.dataset.imageId);const u=new URL(location.href);u.searchParams.set('variant',s.value);history.replaceState({},'',u);});

(function(){
  function init(root){
    root.querySelectorAll('[data-variant-select]').forEach(select=>{
      if(select.dataset.pickerReady)return;
      const variants=Array.from(select.options).map(option=>({option,values:JSON.parse(option.dataset.values),available:option.dataset.available==='true'}));
      if(!variants.length)return;
      const label=select.previousElementSibling;
      if(select.dataset.defaultOnly==='true'){select.hidden=true;if(label?.tagName==='LABEL')label.hidden=true;return;}
      const names=JSON.parse(select.dataset.optionNames);
      const picker=document.createElement('div');picker.className='fawri-options';
      const groups=names.map((name,index)=>{
        const field=document.createElement('fieldset'),legend=document.createElement('legend'),valueLabel=document.createElement('span'),row=document.createElement('div');
        legend.append(document.createTextNode(name+': '),valueLabel);row.className='fawri-option-row';field.append(legend,row);picker.append(field);
        const isColor=/colou?r|couleur|لون/i.test(name);
        const buttons=[...new Set(variants.map(v=>v.values[index]))].map(value=>{
          const button=document.createElement('button');button.type='button';button.className='fawri-option';button.dataset.value=value;button.title=value;button.setAttribute('aria-label',name+': '+value);
          const normalized=value.trim().toLowerCase().replace(/\s+/g,'');
          const colors={grey:'#808080',gray:'#808080',khaki:'#c3b091',beige:'#e8d8b8',gold:'#d4af37',silver:'#c0c0c0',nude:'#e3bc9a',coffee:'#6f4e37'};
          const color=colors[normalized]||(CSS.supports('color',normalized)?normalized:null);
          if(isColor&&color){
            button.classList.add('fawri-swatch');button.style.setProperty('--swatch',color);
            const dot=document.createElement('span');dot.setAttribute('aria-hidden','true');button.append(dot);
          }else{button.textContent=value;}
          button.addEventListener('click',()=>{
            const current=variants.find(v=>v.option.value===select.value)||variants[0];
            const matches=variants.filter(v=>v.values[index]===value);
            const exact=matches.find(v=>v.values.every((x,i)=>i===index||x===current.values[i]));
            const next=exact||matches.find(v=>v.available)||matches[0];
            if(!next)return;
            select.value=next.option.value;select.dispatchEvent(new Event('change',{bubbles:true}));
          });
          row.append(button);return button;
        });
        return {valueLabel,buttons,index};
      });
      function sync(){
        const current=variants.find(v=>v.option.value===select.value)||variants[0];
        groups.forEach(({valueLabel,buttons,index})=>{
          valueLabel.textContent=current.values[index];
          buttons.forEach(button=>{
            button.setAttribute('aria-pressed',String(button.dataset.value===current.values[index]));
          });
        });
      }
      select.before(picker);select.hidden=true;if(label?.tagName==='LABEL')label.hidden=true;
      select.dataset.pickerReady='true';select.addEventListener('change',sync);sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
